import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
var CLASSNAME = 'Icons-up-direction-arrow';
var ID = 'icon-up-direction-arrow';
/* eslint-disable max-len */

export var SVGUpDirectionArrow = function SVGUpDirectionArrow() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M7.73028315,10.8704207 C7.79459287,10.9568069 7.90305551,11 7.98848184,11 C8.09694449,11 8.20444729,10.9568069 8.268757,10.8704207 L13.8704207,5.26971685 C13.9568069,5.18333067 14,5.09694449 14,4.98944169 C14,4.90305551 13.9568069,4.79555271 13.8704207,4.70916653 L13.2676372,4.1274996 C13.2023676,4.04111342 13.0948648,3.99792033 13.0084786,3.99792033 C12.9009758,3.99792033 12.793473,4.04111342 12.7291633,4.1274996 L7.98848184,8.84610462 L3.27083667,4.1274996 C3.18445049,4.04111342 3.09806431,3.99792033 2.99056151,3.99792033 C2.88305871,3.99792033 2.79667253,4.04111342 2.71028635,4.1274996 L2.12861942,4.70916653 C2.04223324,4.79555271 2,4.90305551 2,4.98944169 C2,5.09694449 2.04223324,5.18333067 2.12861942,5.26971685 L7.73028315,10.8704207 Z",
    transform: "translate(8.000000, 7.498960) scale(1, -1) rotate(-360.000000) translate(-8.000000, -7.498960) "
  })));
};
/* eslint-disable max-len */

var UpDirectionArrow = function UpDirectionArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGUpDirectionArrow
  });
};

UpDirectionArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default UpDirectionArrow;